import React from 'react'
import { useForm } from 'react-hook-form'
import { Form } from 'react-bootstrap'
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap'
import { message } from 'antd'

import RewardForm from './RewardForm'

import { storeReward } from '../services'
import { handleError } from '../../../helpers'

export default function NewRewardModal({ visible, onClose, reload }) {
	const { handleSubmit, register, formState: { errors } } = useForm()

	const onSubmit = values => {
		storeReward(values)	
			.then(res => {
				message.success(res.data.message)
				reload()
				onClose()
			})
			.catch(handleError)
	}

	return (
		<Modal isOpen={visible} toggle={onClose}>
			<ModalHeader toggle={onClose}>Agregar nuevo premio</ModalHeader>
			<ModalBody>
				<Form onSubmit={handleSubmit(onSubmit)}>
					<RewardForm 
						register={register}
						errors={errors}
					/>
					<Button color="primary" type="submit">
						Agregar premio
					</Button>
				</Form>
			</ModalBody>
		</Modal>
	)
}